import { EVENTS } from '@archetype-themes/utils/events'
import { getCart, updateAttributes } from './cart.js'

const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

class GiftMessageForm extends HTMLElement {
  constructor() {
    super()
    this.giftToInput = this.querySelector('input[name="gift_to"]')
    this.giftFromInput = this.querySelector('input[name="gift_from"]')
    this.giftMessageInput = this.querySelector('textarea[name="gift_message"]')
    this.giftToEmailInput = this.querySelector('input[name="gift_to_email"]')
    this.giftMessageForm = this.querySelector('.js-cart-gift-form');
    this.saveBtn = this.querySelector('.js-save-gift-message')
    this.cancelBtn = this.querySelector('.js-cancel-gift-message')
    this.closeBtn = this.querySelector('.js-cart-gift-form-close');
  }

  connectedCallback() {
    this.abortController = new AbortController()

    this.saveBtn.addEventListener('click', this.saveGiftMessage.bind(this), {
      signal: this.abortController.signal
    });

    this.cancelBtn.addEventListener('click', this.closeGiftMessageForm.bind(this), {
      signal: this.abortController.signal
    });

    this.giftMessageForm.addEventListener(EVENTS.cartGiftMessageFormClear, this.resetGiftMessageForm.bind(this), {
      signal: this.abortController.signal
    })

    this.giftMessageForm.addEventListener('input', this.updateGiftMessagePreview.bind(this), {
      signal: this.abortController.signal
    })

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.closeGiftMessageForm.bind(this), {
        signal: this.abortController.signal
      })
    }

    this.updateGiftMessagePreview()
  }

  disconnectedCallback() {
    this.abortController.abort()
  }

  clearInputFields() {
    for (const element of this.querySelectorAll('.field__input')) {
      element.value = ''
    }
  }

  async saveGiftMessage() {
    const giftAttributes = {};
    const giftToEmail = this.giftToEmailInput.value;

    if (giftToEmail && !EMAIL_REGEX.test(giftToEmail)) {
      this.displayEmailError();
      return;
    }

    this.saveBtn.classList.add('btn--loading');

    this.clearErrorMessage();

    if (this.giftToInput.value) {
      giftAttributes["gift_to"] = this.giftToInput.value
    }

    if (this.giftFromInput.value) {
      giftAttributes["gift_from"] = this.giftFromInput.value
    }

    if (this.giftMessageInput.value) {
      giftAttributes["gift_message"] = this.giftMessageInput.value
    }

    if (giftToEmail) {
      giftAttributes["gift_to_email"] = giftToEmail
    }

    if (Object.keys(giftAttributes).length > 0) {
      await updateAttributes(giftAttributes);
    }

    document.dispatchEvent(new CustomEvent(EVENTS.cartGiftMessageUpdated, {
      detail: { hasGiftMessage: true }
    }));

    this.saveBtn.classList.remove('btn--loading');
  }

  async resetGiftMessageForm() {
    this.clearInputFields();

    await updateAttributes({
      gift_to: null,
      gift_from: null,
      gift_message: null,
      gift_to_email: null
    });

    this.updateGiftMessagePreview()

    document.dispatchEvent(new CustomEvent(EVENTS.cartGiftMessageUpdated, {
      detail: { hasGiftMessage: false }
    }));
  }

  async closeGiftMessageForm() {
    const { attributes } = await getCart();

    const {
      gift_to: giftTo = '',
      gift_from: giftFrom = '',
      gift_message: giftMessage = '',
      gift_to_email: giftToEmail = ''
    } = attributes;

    this.giftToInput.value = giftTo;
    this.giftFromInput.value = giftFrom;
    this.giftMessageInput.value = giftMessage;
    this.giftToEmailInput.value = giftToEmail;

    this.updateGiftMessagePreview()

    document.dispatchEvent(new CustomEvent(EVENTS.cartGiftMessageFormClose));
  }

  async updateGiftMessagePreview() {
    const giftMessagePreviewEl = this.querySelector('.js-gift-card-preview-text');

    const giftTo = this.giftToInput.value;
    const giftFrom = this.giftFromInput.value;
    const giftMessage = this.giftMessageInput.value;

    giftMessagePreviewEl.innerHTML = `${giftTo ? (`${giftTo}<br/></br>`) : ''}${giftMessage ? (`${giftMessage}<br/><br/>`) : ''}${giftFrom}`;;
  }

  displayEmailError() {
    this.clearErrorMessage()
    this.giftToEmailInput.classList.add('field__input--error');
  }

  clearErrorMessage() {
    this.giftToEmailInput.classList.remove('field__input--error');
  }
}

customElements.define('gift-message-form', GiftMessageForm)
